import "./template_promotions.css";
